
export const skills = [
  {
    id: 1,
    name: 'Javascript',
    link: 'images/javascript.png',
    alt: 'javascript_icon',
    class: 'w-[90px] h-[90px]'
  },
  {
    id: 2,
    name: 'Typescript',
    link: 'images/typescript-logo.png',
    alt: 'typescript_icon',
    class: 'w-[90px] h-[90px]'
  },
  {
    id: 3,
    name: 'Python',
    link: 'images/python.png',
    alt: 'python',
    class: 'w-[100px] h-[90px]'
  },
  {
    id: 4,
    name: 'HTML 5',
    link: 'images/html5.png',
    alt: 'html5_icon',
    class: 'w-[115px] h-[90px]'
  },
  {
    id: 5,
    name: 'CSS 3',
    link: 'images/css3.png',
    alt: 'css3_icon',
    class: 'w-[115px] h-[90px]'
  },
  {
    id: 6,
    name: 'MongoDB',
    link: 'images/mongodb.png',
    alt: 'mongodb_icon',
    class: 'w-[100px] h-[90px]'
  },
  {
    id: 7,
    name: 'express.js',
    link: 'images/expressjs.png',
    alt: 'express_icon',
    class: 'w-[90px] h-[90px]'
  },
  {
    id: 8,
    name: 'React',
    link: 'images/react-js.png',
    alt: 'react_icon',
    class: 'w-[125px] h-[90px]'
  },
  {
    id: 9,
    name: 'Node.js',
    link: 'images/nodejs.png',
    alt: 'node_icon',
    class: 'w-[120px] h-[90px]'
  },
  {
    id: 10,
    name: 'Bootstrap',
    link: 'images/bootstrap-logo.png',
    alt: 'bootstrap_icon',
    class: 'w-[90px] h-[80px]'
  },
  {
    id: 11,
    name: 'Tailwindcss',
    link: 'images/tailwind-logo.png',
    alt: 'tailwindcss_icon',
    class: 'w-[100px] h-[80px]'
  },
  {
    id: 111,
    name: 'Sass',
    link: 'images/sass_logo.png',
    alt: 'sass_icon',
    class: 'w-[100px] h-[100px]'
  },
  {
    id: 12,
    name: 'MySQL',
    link: 'images/mysql_logo.png',
    alt: 'mysql_icon',
    class: 'w-[100px] h-[100px]'
  },
  {
    id: 13,
    name: 'Git',
    link: 'images/git_logo.png',
    alt: 'git_icon',
    class: 'w-[100px] h-[100px]'
  },
  {
    id: 14,
    name: 'Github',
    link: 'images/github-logo.png',
    alt: 'github_icon',
    class: 'w-[100px] h-[100px]'
  },
  {
    id: 15,
    name: 'Mongoose',
    link: 'images/mongoose_logo.png',
    alt: 'mongoose_icon',
    class: 'w-[140px] h-[90px]'
  }
]

export const projects = [
  {
    id: 50,
    name: 'tumblE',
    website: 'https://tumble-1ddc910b2a5b.herokuapp.com/',
    git: 'https://github.com/s0ysau/tumblr#readme',
    picture: 'images/tumble.png',
    description: 'A re-creation of Tumblr.',
    skills_used: ['Javascript', 'MongoDB', 'express.js', 'React', 'Node.js', 'Sass'],
    credentials: 'Credentials - email: guest@mail.com, password: guest12345',
    points:
    ['-Utilized MERN (MongoDB, Express, React, Node.js) stack with a team of 4 to collaboratively build a full stack Tumblr clone ',
      '-Made RESTful API fetch calls to the back-end handling all create, read, update, delete (CRUD) operations ',
      '-Employed Git version control and cohesive group git practices to co-develop this project simultaneously with my peers ',
      '-Designed client-side and server-side architecture leveraging a custom ERD and component hierarchy diagrams ',
      '-Implemented user authentication leveraging JSON web tokens to enforce API authorization ',
      '-Managed team efficiency, organized scope of work and led team meetings as the role of Product Manager / Scrum Master ']
  },
  {
    id: 51,
    name: `DogGo`,
    website: 'https://vimeo.com/891336300?share=copy',
    git: 'https://github.com/ngran4/DogGo-fe#readme',
    picture: 'images/DogGo-logo.png',
    description: 'App that tailors reminders and tips synced with your local weather.',
    skills_used: ['Javascript', 'MongoDB', 'express.js', 'React', 'Node.js', 'CSS 3'],
    credentials: 'Project is not deployed yet.',
    points:
      ['-Collaborated with a team of 5 UX/UI designers and 4 Full Stack Engineers in a 5-day Hackathon where team project was awarded “Crowd Favorite” ',
        '-Developed a MERN (MongoDB, Express, React Native, Node.js) mobile application with integrated AI capabilities, personalizing dog walking schedules and activities based on real-time local weather conditions ',
        '-Generated an Entity-Relationship Diagram (ERD) and a flowchart to visualize the onboarding process and data structure ',
        '-Implemented the Front-end and Back-end components separately, optimizing security and code efficiency ',
        '-Utilized the WeatherAPI to fetch real-time weather data, enabling user notifications ',
        '-Applied agile methodologies to minimize team conflicts and enhance efficiency in delivering a Minimum Viable Product (MVP) ',
      ]
  }, 
  {
    id: 52,
    name: `Booboo's Boba`,
    website: 'https://booboos-boba.netlify.app/',
    git: 'https://github.com/s0ysau/booboosboba#readme',
    picture: 'images/booboosboba-webshot.png',
    description: 'A Ecommerce site for Boba',
    skills_used: ['Javascript', 'React', 'Tailwindcss'],
    credentials: 'No credentials needed',
    points:
      ['-Utilized MERN stack to develop a e-commerce app for quick orders of boba drinks and is easily scalable',
        '-Created ERD and wireframes to visualize the onboarding experience and user experience',
        '-Produced a mock payment platform that replicates real-world payment designs used by restaurants',
        'Used Tailwind CSS to create an easy to use and minimalist User Interface '
      ]
  }, 
  {
    id: 53,
    name: 'MovieApp',
    website: 'https://movieapp-jlc.netlify.app/',
    git: 'https://github.com/s0ysau/React_Movie_App#readme',
    picture: 'images/movieapp.png',
    description: 'A Movies App using an RESTful API called OMDb',
    skills_used: ['Javascript', 'React', 'Tailwindcss'],
    credentials: 'No credentials needed',
    points:
      ['-Constructed an search website where users can find their favorites movies using React.js',
        '-Utilized a third-party API called OMDb API to query user’s movie searches. ',
        '-Configured React Router and utilized React state and hooks to develop a responsive design with Tailwind CSS ',
        '-Future Feature: Employ another API to display other data like actors, genres, etc. ',
        '-Future Feature: Implement a user function and enhance interactions with ratings, user collections, etc. '
      ]
  },
  {
    id: 54,
    name: 'Snakes! The Game',
    website: 'https://snakes-jlc.netlify.app',
    git: 'https://github.com/s0ysau/Snakes_Game',
    picture: 'images/snakes.png',
    description: 'Classic game of Snake.',
    skills_used: ['Javascript', 'HTML 5', 'CSS 3'],
    credentials: 'No credentials needed',
    points:
    ['-Developed a functional classic game of Snake using a Front-end stack of JavaScript, HTML, CSS',
      '-Created two distinct levels with different features to enhance the user experience',
      '-Utilized local storage as a initial way to store user High Scores ',
      '-Created a wireframe as a basis of understanding functionality and design of the application in the conceptual stage ',
      '-Future Feature: Develop a third stage with a different feature that will make it unique from the other stages ',
      '-Future Feature: Store High Scores and credentials in the database '
    ]
  },
  {
    id: 55,
    name: 'Bricky4Legos',
    website: 'https://brickyforlegos.herokuapp.com/home',
    git: 'https://github.com/s0ysau/bricky4legos#readme',
    picture: 'images/bricky4legos.png',
    description: 'Lego API site',
    skills_used: ['Javascript', 'CSS 3', 'MongoDB', 'express.js'],
    credentials: 'Credentials - username: test, password: test',
    points:
    ['-Utilized Back-end focus stack (MongoDB, Express, Node.js, JSX) to create a Lego’s API',
      '-Assembled using MVC pattern to handling all create, read, update, delete (CRUD) operations ',
      '-Implemented user authentication leveraging JSON web tokens to API authorization  ',
      '-Used basic CSS 3 to create a minimalistic User Interface with easy to use User Experience ',
      '-Produced detailed ERD and wireframes to clarify intent and vision '
    ]
  },


]

export default { skills, projects }
